module.exports = __webpack_public_path__ + "static/media/blom-pysanky-114.c547ac7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-114.jpg
// module id = 3677
// module chunks = 13